export const theme = {
    color: {
        white: "#FFFFFF",
        whiteLilac: "#FBFBFE",
        mercury: "#E5E5E5",
        silver: "#C4C4C4",
        slateGray: "#6E7E91",
        dodgerBlue: "#2188FF",
        scienceBlue: "#0366D6",
        lightMineShaft: "#363636B8",
        mineShaft: "#252525",
    },

    shadow: {
        boxShadow: "0px 16px 58px 0px #090A3308, 0px -2px 50px 0px #090A3305",
        boxShadowHover: "0px 16px 58px 0px rgba(9, 10, 51, 0.03), 0px -2px 50px 0px rgba(9, 10, 51, 0.02)",
        shadowButtonHover: "-2px -2px 0px 0px #8CC2FF, 2px 2px 0px 0px #8CC2FF, -2px 2px 0px 0px #8CC2FF, 2px -2px 0px 0px #8CC2FF",
        shadowButtonHoverDarkMode: "-2px -2px 0px 0px #6D93BE, 2px 2px 0px 0px #6D93BE, -2px 2px 0px 0px #6D93BE, 2px -2px 0px 0px #6D93BE",
        shadowButtonActive: "0px 2px 0px 0px rgba(20, 70, 32, 0.20) inset",
    },

    border: {
        borderHeader: "1px solid #D1D5DA4D",
        borderTile: "6px solid #D1D5DA4D",
        borderTileHoverLM: "6px solid rgba(3, 102, 214, 0.20);",
        borderTileHoverDM: "6px solid rgba(3, 102, 214, 0.50);",
        borderHeaderDarkMode: "1px solid #D1D5DA1A",
        borderTileDarkMode: "6px solid #D1D5DA1A",
    },

    fontSize: {
        font12: "12px",
        font14: "14px",
        font16: "16px",
        font17: "17px",
        font18: "18px",
        font20: "20px",
        font22: "22px",
        font24: "24px",
        font30: "30px",
        font38: "38px",
    },

    fontWeight: {
        font400: "400",
        font600: "600",
        font700: "700",
        font900: "900",
    },

    breakpoint: {
        mobile: 768,
        tablet: 992,
        laptop: 1200,
    },
};